import { render, staticRenderFns } from "./TenantSMS.vue?vue&type=template&id=6ebd5fc5&"
import script from "./TenantSMS.vue?vue&type=script&lang=js&"
export * from "./TenantSMS.vue?vue&type=script&lang=js&"
import style0 from "./TenantSMS.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports